import HelperValidate from "utils/helper-validate";
import HelperDate from 'utils/helper-date'

export default class ObjectScan {
	
	static log = ( value ) => {
		console.prefix( 'ObjectScan', value );
	}
	
	/**
	 * Check if the employee is present according to the scan
	 * @param scan
	 * @returns {boolean}
	 */
	static isPresent = ( scan ) => {
		// If scanned out, the employee is not present.
		if( HelperValidate.isValid( scan.scanned_out_at ) ) {
			return false;
		}
		
		return HelperDate.fn.isToday( HelperDate.date( scan.scanned_in_at ) )
	}
}
